import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"
import { PALETTE, NIVO_THEME, formatShort } from "@react/projects/chantiers_dashboard/components/palette"

// exits + base is last year's portfolio, base + entries + indexation is this year's.
const KEYS        = ["exits", "base", "entries", "indexation"]
const LEGEND_KEYS = ["base", "entries", "indexation", "exits"]
const COLORS = {
  base:       "#cbd5e1",
  entries:    PALETTE.emerald,
  indexation: PALETTE.violet,
  exits:      PALETTE.rose,
}

const PortfolioBridge = ({ data, currency }) => {
  const rows = (data || []).map((row) => ({
    year: row.forecast ? `${row.year} ·` : `${row.year}`,
    base: row.base / 100,
    entries: row.entries / 100,
    indexation: row.indexation / 100,
    exits: row.exits / 100,
    total: row.total,
    counts: row.counts,
    forecast: row.forecast,
  }))

  const money = (value) =>
    new Intl.NumberFormat(I18n.locale || "fr", {
      style: "currency", currency: currency || "EUR", maximumFractionDigits: 0,
    }).format(value)

  return (
    <ChartCard
      icon     = "chart-column"
      title    = {I18n.t("contracts_dashboard.charts.portfolio")}
      subtitle = {I18n.t("contracts_dashboard.charts.portfolio_hint")}
      height   = {340}
      empty    = {rows.length === 0 ? I18n.t("contracts_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data          = {rows}
        keys          = {KEYS}
        indexBy       = "year"
        margin        = {{ top: 20, right: 24, bottom: 56, left: 74 }}
        padding       = {0.34}
        colors        = {({ id }) => COLORS[id]}
        borderRadius  = {2}
        enableLabel   = {false}
        axisLeft      = {{ tickSize: 0, tickPadding: 8, format: (v) => formatShort(v * 100) }}
        axisBottom    = {{ tickSize: 0, tickPadding: 10 }}
        theme         = {NIVO_THEME}
        valueFormat   = {(v) => money(v)}
        legends       = {[{
          dataFrom: "keys", anchor: "bottom", direction: "row",
          translateY: 48, itemWidth: 104, itemHeight: 16, symbolSize: 9,
          symbolShape: "circle",
          data: LEGEND_KEYS.map((id) => ({
            id, label: I18n.t(`contracts_dashboard.bridge.${id}`), color: COLORS[id],
          })),
        }]}
        tooltip = {({ id, value, data: row }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "8px 11px", fontSize: 11, borderRadius: 6 }}>
            <div style={{ fontWeight: 700, marginBottom: 3 }}>{row.year}</div>
            <div>{I18n.t(`contracts_dashboard.bridge.${id}`)} : {money(value)}</div>
            <div style={{ opacity: 0.75, marginTop: 3 }}>
              {I18n.t("contracts_dashboard.bridge.total")} : {money(row.total / 100)}
            </div>
            {row.forecast && (
              <div style={{ opacity: 0.75 }}>{I18n.t("contracts_dashboard.billing.planned")}</div>
            )}
          </div>
        )}
      />
    </ChartCard>
  )
}

export default PortfolioBridge
